"use strict";
var appn;
(function (appn) {
    var minicolors;
    (function (minicolors) {
        class Options {
            constructor(change, hide, show) {
                this.animationSpeed = 50;
                this.animationEasing = 'swing';
                this.changeDelay = 150;
                this.control = 'hue';
                this.defaultValue = appn.emptyString;
                this.canSave = true;
                this.format = 'hex';
                this.hideSpeed = 100;
                this.inline = false;
                this.keywords = appn.emptyString;
                this.letterCase = 'uppercase';
                this.opacity = false;
                this.position = 'bottom left';
                this.showSpeed = 100;
                this.theme = 'default';
                this.swatches = [];
                this.change = change;
                this.hide = hide;
                this.show = show || handleColorPickerPosition;
            }
        }
        minicolors.Options = Options;
        const _defaults = new Options();
        function init(change, canSave, customSelector, position) {
            _defaults.change = change ? change : undefined;
            _defaults.canSave = canSave !== undefined ? canSave : true;
            _defaults.position = position !== null && position !== void 0 ? position : _defaults.position;
            const cssSelector = customSelector ? customSelector : $('.colorPicker');
            if (!_defaults.canSave)
                cssSelector.attr('disabled', 'disabled');
            cssSelector.minicolors(_defaults);
        }
        minicolors.init = init;
        function refreshPreviewBody() {
            const body = [];
            for (let i = 1; i < 3; i++) {
                body[i - 1] = String($(`#AppConfig_BackgroundColor${i}`).val());
                if (body[i - 1].length === 0)
                    body[i - 1] = '#FFFFFF';
            }
            const gradientBody = `linear-gradient(top, ${body[0]} 0%, ${body[1]} 100%)`;
            const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr="${body[0]}", endColorstr="${body[1]}");/*For IE7-8-9*/`;
            $.each([appn.emptyString, '-o-', '-moz-', '-webkit-', '-ms-'], function () {
                $('.deviceSkin-content-wrapper').css({ 'background-image': this + gradientBody });
            });
            $('.deviceSkin-content-wrapper').css({ filter: ieGradient });
        }
        minicolors.refreshPreviewBody = refreshPreviewBody;
        function refreshPreviewTitle() {
            const title = [];
            for (let i = 1; i < 4; i++) {
                title[i - 1] = String($(`#AppConfig_TitleColor${i}`).val());
                if (title[i - 1].length === 0)
                    title[i - 1] = '#FFFFFF';
            }
            const gradientBody = `linear-gradient(top, ${title[0]} 0%, ${title[1]} 60%, ${title[2]} 100%)`;
            const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr="${title[0]}", endColorstr="${title[2]}");/*For IE7-8-9*/`;
            $.each(['', '-o-', '-moz-', '-webkit-', '-ms-'], function () {
                $('.previewTitle').css({ 'background-image': this + gradientBody });
            });
            $('.previewTitle').css({ filter: ieGradient });
        }
        minicolors.refreshPreviewTitle = refreshPreviewTitle;
        function toggleColorPickerMulti(customSelector) {
            const colorBoxMulti = customSelector ? customSelector : $('.minicolors .colorPickerMulti');
            colorBoxMulti.siblings('.minicolors-swatch').on('click', function () {
                if ($(this).siblings('.colorPickerMulti').is(':visible')) {
                    $(this).siblings('.colorPickerMulti').hide();
                    $(this).siblings('.minicolors-panel').hide();
                }
                else {
                    $('.minicolors .colorPickerMulti').hide();
                    $('.minicolors .minicolors-panel').hide();
                    $(this).siblings('.colorPickerMulti').show().focus();
                    $(this).siblings('.minicolors-panel').show();
                }
            });
            colorBoxMulti.on('blur', function () {
                $(this).hide();
            });
        }
        minicolors.toggleColorPickerMulti = toggleColorPickerMulti;
        function handleColorPickerPosition() {
            const $input = $(this);
            const $container = $input.closest('.minicolors');
            if ($container.length === 0)
                return;
            const panelHeight = 150;
            const rect = this.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const spaceBelow = windowHeight - rect.bottom;
            const shouldFlip = spaceBelow < panelHeight;
            $container.toggleClass('force-open-above', shouldFlip);
        }
    })(minicolors = appn.minicolors || (appn.minicolors = {}));
})(appn || (appn = {}));
